import React from "react";
import "./global.scss";

const Global = ({children}) => {
    return (
        <>{children}</>
    );
}

export default Global;